export const PricingPanelCss = {
  pricingPanel: {
    height: "100%",
    background: "#222",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    borderRadius: "5px",
    Position: "relative",
    zIndex: 1,
    color: "#fff"
  },
  features: {
    backgroundColor: "#222",
    color: "#ccc",
    border: 0
  },
  panelHeading: {
    padding: "50px 0px 50px"
  },
  pricingFooter: {
    paddingTop: "30px",
    paddingBottom: "40px"
  },
  planBtn: {
    display: "inline-block",
    padding: "12px 40px",
    background: "#333",
    color: "#ffffff",
    borderRadius: "5px",
    fontSize: "16px",
    borderColor: '#333'
  }
};
